const __WEBPACK_NAMESPACE_OBJECT__ = require("d3-shape");